import React from 'react';
import { Trophy, Medal, Award, Crown } from 'lucide-react';

const Ranking = ({ users = [] }) => {
  // Formatear datos de usuarios desde Supabase
  const rankingUsers = users.map((user, index) => ({
    ...user,
    name: user.full_name || user.name || 'Usuario',
    avatar: user.avatar_url || '👤',
    rank: index + 1
  }));

  const getRankIcon = (rank) => {
    switch (rank) {
      case 1:
        return <Crown className="w-6 h-6 text-yellow-500" />;
      case 2:
        return <Medal className="w-5 h-5 text-gray-400" />;
      case 3:
        return <Medal className="w-5 h-5 text-orange-600" />;
      default:
        return <Award className="w-4 h-4 text-purple-400" />;
    }
  };

  const getRankStyle = (rank) => {
    switch (rank) {
      case 1:
        return 'bg-gradient-to-r from-sky-50 to-cyan-50 border-sky-400 shadow-lg scale-105';
      case 2:
        return 'bg-gradient-to-r from-slate-50 to-slate-100 border-slate-300 shadow-md';
      case 3:
        return 'bg-gradient-to-r from-teal-50 to-emerald-50 border-teal-300 shadow-md';
      default:
        return 'bg-white border-slate-200';
    }
  };

  return (
    <div className="w-full">
      <div className="flex items-center gap-3 mb-4 sm:mb-6">
        <div className="p-2 sm:p-3 bg-gradient-to-br from-yellow-100 to-amber-100 rounded-2xl">
          <Trophy className="w-6 h-6 sm:w-8 sm:h-8 text-yellow-600" />
        </div>
        <div>
          <h2 className="text-lg sm:text-xl md:text-2xl font-bold text-gray-800">Ranking</h2>
          <p className="text-xs sm:text-sm text-gray-600">Top estudiantes de anatomía</p>
        </div>
      </div>

      {rankingUsers.length > 0 ? (
        <div className="space-y-2 max-h-[300px] sm:max-h-[400px] overflow-y-auto pr-1 sm:pr-2 scrollbar-thin scrollbar-thumb-purple-300 scrollbar-track-purple-50">
          {rankingUsers.map((user) => (
            <div
              key={user.id}
              className={`flex items-center gap-2 sm:gap-3 p-2 sm:p-3 rounded-xl border-2 transition-all ${getRankStyle(user.rank)}`}
            >
              {/* Rank */}
              <div className="flex-shrink-0 flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8">
                {getRankIcon(user.rank)}
              </div>

              {/* Avatar */}
              <div className="flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 bg-white rounded-full flex items-center justify-center text-lg sm:text-xl border-2 border-purple-200 shadow-sm overflow-hidden">
                {user.avatar_url ? (
                  <img src={user.avatar_url} alt={user.name} className="w-full h-full object-cover" />
                ) : (
                  <span>{user.avatar}</span>
                )}
              </div>

              {/* User Info */}
              <div className="flex-1 min-w-0">
                <h3 className="font-semibold text-xs sm:text-sm text-gray-800 truncate">{user.name}</h3>
                <p className="text-xs text-gray-600 flex items-center gap-1">
                  <Trophy className="w-3 h-3" />
                  {user.score} puntos
                </p>
              </div>

              {/* Rank Number */}
              <div className="flex-shrink-0 text-sm sm:text-lg font-bold text-gray-400">
                #{user.rank}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-6 sm:py-8 text-gray-500">
          <p className="text-xs sm:text-sm">No hay rankings disponibles aún.</p>
          <p className="text-xs mt-1 sm:mt-2">¡Sé el primero en jugar y aparecer en el ranking!</p>
        </div>
      )}
    </div>
  );
};

export default Ranking;
